export const APPEND_WORKLOAD_BUSINESS_CASE = `
  mutation AppendWorkloadBusinessCase($input: AppendBusinessCaseInput!) {
    appendWorkloadBusinessCase(input: $input) {
      workloadId
      asIsAmount
      targetPct
      valueType
      opportunity
      capturedAt
      capturedBy
    }
  }
`
